import { Link } from 'react-router-dom';

export default function TrustBlock() {
  const items = [
    { title: 'Expert-Curated', desc: 'Every Mulebuy Spreadsheet comparison and guide is researched and verified by data management professionals.' },
    { title: '2026 Updated', desc: 'All Mulebuy Spreadsheet content is refreshed regularly with the latest tools and best practices for this year.' },
    { title: 'Real Tutorials', desc: 'Step-by-step Mulebuy Spreadsheet tutorials based on real-world usage scenarios and workflows.' },
    { title: 'Transparent Info', desc: 'Honest, unbiased Mulebuy Spreadsheet information — no hidden affiliate agendas or misleading claims.' },
  ];

  return (
    <section className="bg-background-100 section-padding">
      <div className="container-custom">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="lg:w-2/5">
            <div className="rounded-[40px] overflow-hidden w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20clean%20modern%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20on%20a%20light%20wooden%20desk%2C%20warm%20natural%20sunlight%20from%20window%2C%20minimalist%20office%20setup%20with%20a%20small%20plant%20and%20coffee%20cup%2C%20soft%20cream%20walls%2C%20editorial%20photography%20style%2C%20calm%20productive%20atmosphere%2C%20clean%20composition%2C%20warm%20neutral%20tones&width=800&height=1000&seq=trust-mulebuy-01&orientation=portrait"
                alt="Mulebuy Spreadsheet trusted resource workspace"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:w-3/5">
            <span className="inline-flex items-center px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold font-label mb-4">
              Why Trust This Hub
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight">
              Real Users Trust<br />
              <span className="text-foreground-400">Mulebuy Spreadsheet</span> Resources
            </h2>
            <p className="text-sm text-foreground-500 mt-4 leading-relaxed max-w-lg">
              This Mulebuy Spreadsheet resource hub is built on thorough research and practical experience. Every guide, comparison, and tutorial is crafted to deliver accurate, actionable information for anyone looking to master their data workflows.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
              {items.map((item) => (
                <div key={item.title} className="flex items-start gap-3 p-4 rounded-xl bg-background-50">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-800 font-label">{item.title}</h4>
                    <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/what-is-mulebuy-spreadsheet"
              className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-background-50 border border-background-300 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 hover:border-background-400 transition-all font-label group"
            >
              Read Full Guide
              <span className="w-5 h-5 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}